// extracted by mini-css-extract-plugin
module.exports = {"container":"loading-screen__container___35Y_C","bars":"loading-screen__bars___ZL3YB","text":"loading-screen__text___3YrJV"};